import axios from 'axios';
import { API } from '../../utils/api';
import { ACCESS_TOKEN, DOCUMENT_SERVICE_PROVIDER_CODE } from '../../utils/constants';
import authUtil from '../../utils/AuthUtils';
/**
 * Fetches all workspaces from the API that the user is a member of.
 * @returns {Promise<Object[]>} Promise resolving to an array of workspaces
 * @throws {Error} If there is an error fetching workspaces
 */
async function getWorkspaces() {
  let AUTH_TOKEN = localStorage.getItem(ACCESS_TOKEN);
  if(!AUTH_TOKEN) {
    authUtil.clearSession();
    window.location.href = `${window.location.origin}/login`;
  }
  return axios
    .get(API.USER.getWorkspaces, {
      headers: {
        Authorization: `Bearer ${AUTH_TOKEN}`,
      },
    })
    .then((res) => {
      if (res){
        let response = res.data;

        response = response.filter(r => {
          if (r.clientTypeRegistrationDetails && Array.isArray(r.clientTypeRegistrationDetails)) {
              return r.clientTypeRegistrationDetails.some(detail => {
                  if (detail.serviceProviderRegistrationDetails && Array.isArray(detail.serviceProviderRegistrationDetails)) {
                      return detail.serviceProviderRegistrationDetails.some(provider => 
                          provider.serviceProviderCode === DOCUMENT_SERVICE_PROVIDER_CODE
                      );
                  }
                  return false;
              });
          }
          return false;
        });

        return response;
      }
      return  [];
    })
    .catch((error) => {
      console.error('Error fetching workspaces:', error);
      authUtil.clearSession();
      throw error;
    });
}

export default getWorkspaces;
